<template>
  <div class="treat_detail">
    <v-card flat style="margin-top: 20px">
      <v-card-text>
        <v-overlay absolute dark :value="overlay"> </v-overlay>

        <div style="padding-left: 5px; margin: 7px 0px">
          <v-card outlined flat>
            <v-card-title class="caption">expectations</v-card-title>
            <v-card-text>
              {{ view.expectations }}
            </v-card-text>
          </v-card>
        </div>

        <div style="padding-left: 5px">
          <v-card outlined flat>
            <v-card-title class="caption">comment</v-card-title>
            <v-card-text> {{ view.comment }} fgrwwr </v-card-text>
          </v-card>
        </div>

        <div style="padding-left: 5px; margin: 7px 0px">
          <v-card outlined flat>
            <v-card-title class="caption">other</v-card-title>
            <v-card-text>
              {{ view.other }}
            </v-card-text>
          </v-card>
        </div>

        <div style="padding-left: 5px; margin: 7px 0px">
          <v-card outlined flat>
            <v-card-title class="caption">schedule_next_visit</v-card-title>
            <v-card-text>
              {{ view.schedule_next_visit | custDate }}
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Utils from "../../../mixins/utils";
import Restful from "@/services/RestFul";
export default {
  props: {
    medavId: {
      type: String,
    },
  },
  mixins: [Utils],
  data: () => ({
    overlay: true,
    absolute: true,
    view: {},
  }),
  watch: {
    medavId: function (v) {
      let d = this._decode(v);
      console.log("d:", d);
      this.list();
    },
  },
  created() {
    this.list();
  },
  methods: {
    list() {
      this.overlay = true;
      let self = this;
      let d = this._decode(this.medavId);
      console.log("dis:", d);
      Restful.medics.treatment.summary
        .list(d)
        .then((response) => {
          console.log(response.data);
          this.view = response.data;
          this.overlay = false;
        })
        .catch((error) => {
          console.log(error.response);
          self.overlay = false;
        });
    },
  },
};
</script>
